import React, { useState, useEffect } from 'react';
import { getTokenFromLocalStorage, getUserFromLocalStorage } from '../../utils/auth';
import { ButtonComponent } from '../../components/elements';
import IconAlertComponent from '../../components/IconAlertComponent';
import IconFieldComponent from '../../components/fields/IconFieldComponent';
import LogoComponent from '../../components/LogoComponent';
import { authAPI } from '../../services';
import { readNext } from '../../utils/nextParam';

export default function LoginPage() {
  // Check if user is already logged in
  useEffect(() => {
    const token = getTokenFromLocalStorage();
    const user = getUserFromLocalStorage();

    if (token && user) {
      console.log('User already logged in:', user);
      // #140539 (AC3): đã đăng nhập sẵn mà mở /login?next=… thì đi thẳng tới nơi định vào.
      window.location.href = readNext(window.location.search);
    }
  }, []);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Sử dụng authAPI.login thay vì apiClient trực tiếp
      const response = await authAPI.login({
        username: formData.username,
        password: formData.password,
      });

      // Xử lý response thành công
      // Response format từ API mới:
      // {
      //   "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
      //   "user": {
      //     "id": "admin-1",
      //     "full_name": "Administrator",
      //     "username": "admin",
      //     "role": "ADMIN",
      //     "branch_id": "branch-1",
      //     "avatar_url": null,
      //     "citizen_id": null,
      //     "phone_number": "0901234567",
      //     "email": "admin@hrm-coffee.com",
      //     "telegram_id": null,
      //     "base_salary": "15000000",
      //     "status": "ACTIVE",
      //     "join_date": "2025-10-07T03:45:20.381Z",
      //     "last_login": null,
      //     "mfa_enabled": false,
      //     "created_at": "2025-10-07T03:45:20.383Z",
      //     "updated_at": "2025-10-07T03:45:20.383Z"
      //   }
      // }

      console.log('Login successful:', response);

      if (response.access_token && response.user) {
        setSuccess(`Đăng nhập thành công! Chào mừng ${response.user.full_name}`);

        // #140539 (AC3): quay lại ĐÚNG trang người dùng định vào (đủ cả params), không đá về
        // trang chủ — nếu không thì link sâu trong tin Telegram coi như vô nghĩa với người chưa
        // đăng nhập. `readNext` đã chặn open-redirect, giá trị lạ thì về '/' như cũ.
        const nextUrl = readNext(window.location.search);

        // Redirect sau 1.5 giây để user thấy thông báo thành công
        setTimeout(() => {
          window.location.href = nextUrl;
        }, 1500);
      } else {
        setError('Đăng nhập thất bại. Vui lòng thử lại.');
      }
    } catch (err) {
      console.error('Login error:', err);

      // Xử lý lỗi từ API
      let errorMessage = 'Đăng nhập thất bại. Vui lòng thử lại.';

      if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.message) {
        errorMessage = err.message;
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="mc-auth">
      <img
        src="images/pattern.webp"
        alt="pattern"
        className="mc-auth-pattern"
      />
      <div className="mc-auth-group">
        <LogoComponent
          src="images/micabit-icon-logo.svg"
          alt="logo"
          href="/ecommerce"
          className="mc-auth-logo"
        />
        {success && (
          <IconAlertComponent
            key="success"
            classes={'green'}
            icon={'verified'}
            title={'Thành công!'}
            text={success}
          />
        )}
        {error && (
          <IconAlertComponent
            key="error"
            classes={'red'}
            icon={'report'}
            title={'Lỗi!'}
            text={error}
          />
        )}
        <h4 className="mc-auth-title">Đăng nhập</h4>
        <form
          className="mc-auth-form"
          onSubmit={handleSubmit}
        >
          <IconFieldComponent
            icon="person"
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            classes="w-100 h-sm"
            placeholder="Nhập tên đăng nhập"
            required
          />
          <IconFieldComponent
            icon="lock"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            classes="w-100 h-sm"
            placeholder="Nhập mật khẩu"
            passwordVisible={true}
            required
          />

          <ButtonComponent
            className="mc-auth-btn h-sm"
            type="submit"
            disabled={loading}
          >
            {loading ? 'Đang đăng nhập...' : 'Đăng nhập'}
          </ButtonComponent>
          {/* <AnchorComponent className="mc-auth-forgot" to="/forgot-password">{t('forgot_password')}</AnchorComponent> */}
          {/* <div className="mc-auth-divide"><span>{t('or')}</span></div>
                    <div className="mc-auth-connect">
                        <AnchorComponent to="#" className="twitter h-sm">
                            <i className="icofont-twitter"></i>
                            <span>Continue with Twitter</span>
                        </AnchorComponent>
                        <AnchorComponent to="#" className="facebook h-sm">
                            <i className="icofont-facebook"></i>
                            <span>Continue with Facebook</span>
                        </AnchorComponent>
                    </div> */}
        </form>
        {/* <div className="mc-auth-navigate">
                    <span>Don't have an account?</span>
                    <AnchorComponent to="/register">{t('register')}</AnchorComponent>
                </div> */}
      </div>
    </div>
  );
}
